/* eslint-disable no-useless-catch */
import { algoliaQuery } from 'api/algolia'
import { finalPrice, productPriceInventory } from 'api/mdl22'

export const fetchPriceInventory = (PriceProducts, Customer) => {
  return async (dispatch, getState) => {
    const { company } = getState()

    const companyId = company.CompanyId
    const companyCode = company.CompanyCode
    const WarehouseId = company.WarehouseId
    const payload = {
      CompanyId: companyId,
      CompanyCode: companyCode,
      WarehouseId,
      ProductIds: PriceProducts || [],
      PriceListId: Customer?.PriceListId ? Customer.PriceListId : null,
      UoMId: null,
    }

    try {
      const response = await productPriceInventory(payload)
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      } else {
        return null
      }
    } catch (err) {
      return null
    }
  }
}

export const getPriceInventoryGeneral = payload => async () => {
  try {
    const response = await productPriceInventory(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return response
    }
  } catch (err) {
    throw err
  }
}

export const getFinalPrice = (PriceProducts, Client) => {
  return async (dispatch, getState) => {
    const { company } = getState()

    const companyId = company.CompanyId
    const WarehouseId = company.WarehouseId

    const payload = {
      CompanyId: companyId,
      WarehouseId,
      ProductId: PriceProducts || [],
      CustomerId: Client?.CustomerId ? Client.CustomerId : null,
    }

    try {
      const response = await finalPrice(payload)
      const { data } = response
      if (response.status === 200 && data.Data) {
        return data.Data
      } else {
        return null
      }
    } catch (err) {
      throw err
    }
  }
}

export const fetchAlgoliaQuery = payload => async () => {
  try {
    const response = await algoliaQuery(payload)
    const { data, status } = response
    if (status === 200 && data) {
      return response
    }
  } catch (err) {
    console.error('Error algoliaQueryAction', err)
    throw err
  }
}
